export const RecordsNo = [
  {id: '20', name: '20'},
  {id: '50', name: '50'},
  {id: '75', name: '75'},
  {id: '100', name: '100'},
]

export const Prefix = [
  {
    id: 'Mr.',
    name: 'OPTIONS.MR',
  },
  {
    id: 'Ms.',
    name: 'OPTIONS.MS',
  },
  {
    id: 'Prefer not to say',
    name: 'OPTIONS.PREFER_NOT_TO_SAY',
  },
]

export const RecordStatus = [
  {
    id: 'Pending',
    name: 'OPTIONS.PENDING',
  },
  {
    id: 'Approved',
    name: 'OPTIONS.APPROVED',
  },
  {
    id: 'Rejected',
    name: 'OPTIONS.REJECTED',
  },
]

export const Genders = [
  {
    id: 1,
    name: 'OPTIONS.MALE',
  },
  {
    id: 2,
    name: 'OPTIONS.FEMALE',
  },
  {
    id: 3,
    name: 'OPTIONS.PREFER_NOT_TO_SAY',
  },
]
